export const GET_OWNED_DATASPACES = 'GET_OWNED_DATASPACES';
export const GET_PARTICIPANT_DET = 'GET_PARTICIPANT_DET';
export const GET_SERVICE_OVERVIEW = 'GET_SERVICE_OVERVIEW';
export const GET_DATASPACE_DETAILS = 'GET_DATASPACE_DETAILS';
export const GET_ALLOCATE_CONNECTOR_ORIGIN_DETAILS = 'GET_ALLOCATE_CONNECTOR_ORIGIN_DETAILS';
export const GET_APPLICATION_DATA = 'GET_APPLICATION_DATA';
